module.exports = __webpack_public_path__ + "img/fullsizeoutput_9a95.37cff45f.37cff45f.jpeg";